//INDIVIDUAL ROLE IDS
export const MATTS_ADMIN = "MATTS Admin";
export const USER_ACCOUNTS_ADMIN = "User Accounts Admin";
export const LOGISTICS_MANAGER = "Logistics Manager";
export const MANUFACTURING_MANAGER = "Manufacturing Manager";
export const PRODUCTION_MANAGER = "Production Manager";
export const RMA_ADMIN =  "RMA Admin";
export const RMA_REQUESTER = "RMA Requester";
export const SHIPPING_MANAGER = "Shipping Manager";
export const RMA_TECHNICIAN ="RMA Technician";

// ROLES GROUPING FOR MODULES
export const USER_ADMIN_MODULE = [ MATTS_ADMIN, USER_ACCOUNTS_ADMIN ];
export const RMA_ADMIN_MODULE = [ MATTS_ADMIN, RMA_ADMIN];
export const CATALOG_MODULE = [ MATTS_ADMIN ]; 
export const INVENTORY_MODULE = [ MATTS_ADMIN ];
export const LOCATIONS_MODULE = [ MATTS_ADMIN ];
export const BINDING_MODULE = [ MATTS_ADMIN, PRODUCTION_MANAGER, MANUFACTURING_MANAGER ];
export const PACKING_MODULE = [ MATTS_ADMIN, PRODUCTION_MANAGER, MANUFACTURING_MANAGER ];
export const PREPPING_MODULE = [ MATTS_ADMIN, SHIPPING_MANAGER, MANUFACTURING_MANAGER ];
export const SHIPPING_MODULE = [ MATTS_ADMIN, SHIPPING_MANAGER, MANUFACTURING_MANAGER ];
export const LOGISTICS_REPORTS_MODULE = [ MATTS_ADMIN, SHIPPING_MANAGER, MANUFACTURING_MANAGER , LOGISTICS_MANAGER ];
export const RMA_REQUEST_MODULE = [ MATTS_ADMIN , RMA_REQUESTER, LOGISTICS_MANAGER ];
export const RMA_ACTION_MODULE = [ MATTS_ADMIN, RMA_ADMIN, RMA_TECHNICIAN];
export const RMA_DIAGNOSIS_MODULE = [ MATTS_ADMIN ,RMA_ADMIN, RMA_TECHNICIAN];
export const RMA_REPORTS_MODULE = [ MATTS_ADMIN ,RMA_ADMIN, LOGISTICS_MANAGER, RMA_TECHNICIAN ];
export const ML_MODULE =[MATTS_ADMIN];
